export function getOrCreateUserId() {
    try {
        // Prefer Firebase UID if available (set by AuthProvider)
        const fuid = localStorage.getItem('firebase_uid');
        if (fuid && fuid.length > 0)
            return fuid;
        const key = 'user_id';
        let id = localStorage.getItem(key);
        if (!id) {
            id = `u_${Math.random().toString(36).slice(2, 10)}_${Date.now().toString(36)}`;
            localStorage.setItem(key, id);
        }
        return id;
    }
    catch {
        return `u_${Date.now()}`;
    }
}
function readEnv(_name) { return undefined; }
export function getApiBase() {
    const cap = globalThis?.Capacitor;
    const isNative = typeof cap?.isNativePlatform === 'function' ? cap.isNativePlatform() : !!cap?.platform;
    if (isNative)
        return 'https://api.mallorb.com';
    const isDevWebHost = (typeof window !== 'undefined' && /localhost|127\.0\.0\.1/.test(window.location?.hostname || ''));
    const isDevNode = (globalThis?.process?.env?.NODE_ENV === 'development');
    return (isDevNode || isDevWebHost ? 'http://localhost:8787' : 'https://api.mallorb.com');
}
export function getWsBase() {
    const api = getApiBase();
    if (api.startsWith('https://'))
        return api.replace('https://', 'wss://');
    if (api.startsWith('http://'))
        return api.replace('http://', 'ws://');
    // Final fallback: production domain
    return 'wss://api.mallorb.com';
}
// Optional separate image upload base; falls back to API base
export function getImageApiBase() {
    return getApiBase();
}
function normalizeLocalhostForMobile(urlStr) {
    return urlStr;
}
// Resolve a possibly relative server path to an absolute URL on the current API host
export function resolveServerUrl(pathOrUrl) {
    if (!pathOrUrl)
        return undefined;
    const s = String(pathOrUrl).trim();
    if (!s)
        return undefined;
    // Already absolute or data/blob etc.
    if (/^https?:\/\//i.test(s) || s.startsWith('data:') || s.startsWith('blob:') || s.startsWith('capacitor:') || s.startsWith('asset:')) {
        return s;
    }
    const base = getImageApiBase().replace(/\/$/, '');
    const path = s.startsWith('/') ? s : `/${s}`;
    return `${base}${path}`;
}
// Base URL for sharing links (renderer entry point), preferring current origin when running on web.
export function getAppBaseUrl() {
    try {
        const origin = window.location.origin || '';
        const protocol = window.location.protocol || '';
        if (/^https?:$/i.test(protocol) && origin) {
            return origin.replace(/\/$/, '');
        }
    }
    catch { }
    // Fallback to API host as app host (same domain) in production
    const api = getApiBase();
    return api.replace(/\/$/, '');
}
